export default __webpack_public_path__ + "73f7d0fe840ee8103c6cb5e43b13efb4.jpg";